import { Card } from './Card';
export { Card };
/**
 * @deprecated Please use named import
 */
export default Card;
//# sourceMappingURL=index.js.map